import React, { useMemo } from "react";
import { get } from "lodash";
import { dateToViewFormat } from "../../utils/date";
import Editor from "../SunEditor";



// const data = JSON.parse(localStorage.getItem('TEST_DATA'));
// const TaskCommonDraftPrint = () => {
const TaskCommonDraftPrint = ({ data }) => {
  // TEST START
  // localStorage.setItem('TEST_DATA', JSON.stringify(data));
  // console.log('TaskCommonDraftPrint FORM : ')
  // console.log(data)
  // TEST END

  const approvers = useMemo(() =>
    get(data, 'approvalTarget.approvals', []).filter((i) => i.type === "approver")
    , [data])
  // const references = useMemo(() =>
  //   get(data, 'approvalTarget.approvals', []).filter((i) => i.type === "reference")
  //   , [data])

  return <>{
    data && <div className="task-common-draft-print-wrap">

      <div className="document-approvals">
        <h1 className="title">
          기&nbsp;&nbsp;안&nbsp;&nbsp;용&nbsp;&nbsp;지
        </h1>
        <div className="approvers-wrap">
          {approvers.map((approver) =>
            <div className="approver-item">
              <div className="approver-name">
                <div className="approver-grade">
                  {get(approver, 'approverEmployee.companyGrade.name', ' ')}
                </div>
                <div>
                  {approver.approverEmployee.name}
                </div>
              </div>
              <div className="approver-sign">
                {
                  get(approver, 'employeeSign.file.fileUrl') &&
                  <img src={get(approver, 'employeeSign.file.fileUrl')} alt={approver.approverEmployee.name} />
                }
              </div>
              <div className="approver-sign-date">
                {
                  get(approver, 'signedTime') ? <>
                    {dateToViewFormat(get(approver, 'signedTime'), "YY.MM.DD HH:mm")}
                  </> : "미결재"
                }
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="document-header">
        <div className="doc-options display-table">
          <div className="display-table-row">
            <div className="display-table-cell th">
              문서번호
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.docNum', "&nbsp;")}&nbsp;
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th">
              처리기간
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.processingPeriod', "&nbsp;")}&nbsp;
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th" style={{ width: '104px' }}>
              시행일자
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.effectiveDate', "&nbsp;")}&nbsp;
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th">
              보존년한
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.retentionYear', "&nbsp;")}&nbsp;
            </div>
          </div>
        </div>
        <div className="references-wrap display-table">
          <div className="display-table-row">
            <div className="display-table-cell th">
              경&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;유
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.through', "&nbsp;")}
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th">
              수&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;신
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.receive', "&nbsp;")}
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th">
              참&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.refer', "&nbsp;")}
            </div>
          </div>
        </div>
      </div>


      <div className="document-contnets">
        {/* <div className="references-wrap display-table">
        <div className="display-table-row">
          <div className="display-table-cell th">
            참&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조
          </div>
          <div className="display-table-cell td">
            {references.map((reference, i) => <>
              {i > 0 ? ', ' : ''}
              {get(reference, 'approverEmployee.companyGrade.name', ' ')}
              {reference.approverEmployee.name}
            </>)}
          </div>
        </div>
      </div> */}

        <div className="doc-instructions display-table">
          <div className="display-table-row">
            <div className="display-table-cell th">
              지시사항
            </div>
            <div className="display-table-cell td instructions-content">
              {get(data, 'data.draft.instructions') ? <>{get(data, 'data.draft.instructions')}<br /></> : ''}
              {approvers.filter((a) => !!a.comment).map((a) => `${a.approverEmployee.name} : ${a.comment}`)}
              &nbsp;
            </div>
          </div>
          <div className="display-table-row">
            <div className="display-table-cell th">
              제&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;목
            </div>
            <div className="display-table-cell td">
              {get(data, 'data.draft.title', "&nbsp;")}
            </div>
          </div>
        </div>
        <div className="doc-content">

          <Editor
            readOnly={true}
            value={get(data, 'data.draft.content', "&nbsp;")}
          />
        </div>
      </div>
    </div>
  }</>;
};
export {
  TaskCommonDraftPrint,
};
export default TaskCommonDraftPrint;
